// Tooltips
"use strict";

import Tabs from "../lib/tabs";

document.querySelectorAll("[data-tabs]").forEach(el => new Tabs(el));
